
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetotuljapurcabbooking() {



    const cardData =
    {
        keyword: 'Pune to Tuljapur Cab Booking Services',
        heading: 'S9 Travels: Pune to Tuljapur Cab Booking Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable cab services for your journey from Pune to Tuljapur. Tuljapur is famous for the ancient Tulja Bhavani Temple, a major pilgrimage site in Maharashtra. Whether you are traveling for religious purposes or exploring the town is heritage, we ensure a smooth and hassle-free journey. Tuljapur is located approximately 230 km from Pune, with a travel time of around 4.5 to 5 hours by road. Our well-maintained fleet and professional drivers ensure a safe and comfortable ride, providing you with the best travel experience.',

        top: 'Top Places to Visit in Tuljapur with S9 Travels',

"topPlaces": [
    {
      "title": "Tulja Bhavani Temple",
      "description": "The Tulja Bhavani Temple is the primary attraction in Tuljapur, dedicated to Goddess Bhavani, a form of Goddess Durga. The temple is a significant religious site and is considered one of the 51 Shakti Peethas in India. Devotees come from all over to seek the blessings of the goddess, and the temple's serene atmosphere makes it a must-visit."
    },
    {
      "title": "Tuljapur Fort",
      "description": "The Tuljapur Fort, situated near the temple, holds historical significance. Though in ruins, the fort offers an interesting glimpse into the town’s history and serves as an excellent spot for photography and exploration. The fort's location provides panoramic views of the surrounding areas."
    },
    {
      "title": "Bhavani Mandir",
      "description": "The Bhavani Mandir is another important religious site near the Tulja Bhavani Temple. Dedicated to Goddess Bhavani, this temple is a significant part of the pilgrimage route in the region."
    },
    {
      "title": "Ghatshila",
      "description": "Ghatshila is a sacred hill located near Tuljapur. It is believed to be the site where Goddess Bhavani performed penance. Visitors often hike up to the hilltop to offer prayers and enjoy the scenic surroundings."
    },
    {
      "title": "Siddheshwar Temple",
      "description": "The Siddheshwar Temple is located near Tuljapur and is dedicated to Lord Shiva. The temple is known for its peaceful ambiance and intricate carvings. It is a great spot for devotees and visitors looking to explore the spiritual side of the town."
    },
    {
      "title": "Jain Temples of Tuljapur",
      "description": "Tuljapur is also home to several Jain temples, each with unique architecture and historical significance. These temples are perfect for history enthusiasts and those interested in Jainism and its traditions."
    },
    {
      "title": "Tungabhadra River",
      "description": "The Tungabhadra River, which flows through the town, adds to the natural beauty of Tuljapur. The river banks are peaceful and scenic, ideal for a relaxing walk or a moment of reflection after visiting the temples."
    },
    {
      "title": "Dattaguru Ashram",
      "description": "The Dattaguru Ashram is a peaceful spiritual retreat located near Tuljapur. Devotees visit this ashram for spiritual healing, meditation, and to seek guidance from the spiritual leaders here."
    },
    {
      "title": "Ganapati Temple",
      "description": "The Ganapati Temple is a charming little temple located in the heart of Tuljapur. It is dedicated to Lord Ganesha, and the peaceful surroundings make it a lovely place to visit for prayer and tranquility."
    }
],

"services": [
    {
      "name": "Book Pune to Tuljapur Taxi",
      "description": "Traveling from Pune to Tuljapur? S9 Travels offers comfortable and reliable taxi services for a smooth journey to Tuljapur, known for its famous Tulja Bhavani Temple. Whether you’re visiting for a religious trip or a leisure tour, we provide a fleet of well-maintained vehicles for your convenience and comfort."
    },
    {
      "name": "Book Pune to Tuljapur Cab Service",
      "description": "Booking a cab service from Pune to Tuljapur is easy with S9 Travels. We offer both one-way and round-trip options to suit your needs. Our professional drivers and well-maintained vehicles guarantee a smooth and pleasant journey from Pune to Tuljapur, making your trip comfortable and stress-free."
    },
    {
      "name": "Book Pune to Tuljapur One-Way Taxi",
      "description": "If you need a one-way taxi from Pune to Tuljapur, S9 Travels provides affordable and convenient services. Whether you're traveling solo or with family, we offer well-maintained vehicles and experienced drivers for a seamless one-way trip to your destination."
    },
    {
      "name": "Book Pune to Tuljapur Round Trip",
      "description": "For a round trip to Tuljapur, choose S9 Travels for an affordable and reliable option. We provide flexible booking options, allowing you to enjoy your visit to Tuljapur and return to Pune at your preferred time. Our round-trip service includes a comfortable ride both ways, ensuring a hassle-free journey."
    },
    {
      "name": "Book Pune to Tuljapur Taxi Fare",
      "description": "At S9 Travels, we offer transparent and affordable taxi fares for your journey from Pune to Tuljapur. You can rely on us for competitive pricing with no hidden charges, allowing you to plan your trip with peace of mind. Contact us for a personalized taxi fare quote based on your requirements."
    },
    {
      "name": "Book Pune to Tuljapur Car Rental",
      "description": "For travelers who prefer flexibility and independence, S9 Travels provides car rental services from Pune to Tuljapur. Rent a car and explore the beautiful city at your own pace. Our fleet includes a variety of vehicles to match your preferences and budget, offering comfort and convenience for your entire trip."
    },
    {
      "name": "Book Pune to Tuljapur Luxury Taxi",
      "description": "For those looking for a more premium experience, S9 Travels offers luxury taxi services for your journey from Pune to Tuljapur. Travel in comfort with our luxury vehicles, equipped with top-notch amenities. Enjoy a relaxed and stylish ride while visiting Tulja Bhavani Temple or exploring the town."
    },
    {
      "name": "Book Pune to Tuljapur Efficient Taxi",
      "description": "S9 Travels offers Efficient Taxi services for budget-conscious travelers. Share the ride with other passengers and enjoy a comfortable journey at a lower cost. Our Efficient Taxis are a great option if you're looking to save on transportation expenses without compromising on comfort and safety."
    },
    {
      "name": "Tuljapur Temple Taxi Service",
      "description": "Visiting Tuljapur for the Tulja Bhavani Temple? S9 Travels provides specialized temple taxi services to ensure that you have a safe and comfortable journey to the temple. Our drivers are familiar with the best routes and will make your visit hassle-free, ensuring you reach your destination in the most convenient way possible."
    },
    {
      "name": "Pune to Tuljapur Private Taxi",
      "description": "For a private and personalized experience, S9 Travels offers private taxi services from Pune to Tuljapur. Whether you are traveling alone, with family, or in a group, we provide dedicated private taxis that offer flexibility and comfort, ensuring a relaxing journey."
    },
    {
      "name": "Affordable Tuljapur Taxi",
      "description": "Looking for an affordable taxi to Tuljapur? S9 Travels provides cost-effective taxi services without compromising on quality. Our budget-friendly options ensure that you get the best value for your journey, with comfortable rides and professional drivers at competitive prices."
    },
    {
      "name": "Group Cab Booking for Tuljapur",
      "description": "If you're planning a group trip to Tuljapur, S9 Travels offers group cab booking services. We have spacious vehicles that can accommodate groups of all sizes. Whether you're visiting the temple or exploring the area, we ensure that your entire group travels comfortably."
    },
    {
      "name": "Tuljapur Road Trip Taxi",
      "description": "Embark on a scenic road trip to Tuljapur with S9 Travels. Our road trip taxi services offer a relaxed and comfortable journey with the flexibility to stop and explore along the way. Whether you’re traveling for leisure or pilgrimage, we guarantee a smooth and enjoyable road trip experience."
    },
    {
      "name": "Tuljapur Temple Tour Cab",
      "description": "For those specifically visiting the Tulja Bhavani Temple, S9 Travels offers temple tour cab services. Our drivers are familiar with the best routes and timings, ensuring that you have a seamless experience while visiting the temple. Book a cab for a peaceful and hassle-free Tuljapur temple tour."
    },
    {
      "name": "Tuljapur Cab Fare from Pune",
      "description": "At S9 Travels, we offer transparent pricing for all Tuljapur cab bookings. Whether you are opting for a one-way taxi, a round trip, or a group tour, we provide upfront quotes with no hidden fees. Contact us for an accurate and affordable Tuljapur cab fare from Pune."
    }
],

"tableData": [
  ["Book Pune To Tuljapur Taxi", "Book Pune To Tuljapur Cab Service"],
  ["Book Pune To Tuljapur One-Way Taxi", "Book Pune To Tuljapur Round Trip"],
  ["Book Pune To Tuljapur Taxi Fare", "Book Pune To Tuljapur Car Rental"],
  ["Book Pune To Tuljapur Luxury Taxi", "Book Pune To Tuljapur Efficient Taxi"],
  ["Tuljapur Temple Taxi Service", "Pune to Tuljapur Private Taxi"],
  ["Affordable Tuljapur Taxi", "Group Cab Booking for Tuljapur"],
  ["Tuljapur Road Trip Taxi", "Tuljapur Temple Tour Cab"],
  ["Tuljapur Cab Fare from Pune", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality when traveling to the sacred town of Tuljapur. Our drivers ensure timely pickups and drop-offs, so you can visit the famous Tulja Bhavani Temple and other attractions without any stress."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a range of well-maintained vehicles, including sedans, SUVs, and premium cars, for your journey from Pune to Tuljapur. All our vehicles come with air conditioning, comfortable seating, and spacious interiors, ensuring a relaxing ride throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes to Tuljapur, ensuring a smooth, safe, and hassle-free journey. They prioritize your safety and comfort, allowing you to focus on your pilgrimage or leisure trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Tuljapur trip. There are no hidden charges, and we provide a clear breakdown of costs so you know exactly what to expect, making your journey affordable and stress-free."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey as you head to Tuljapur."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates round the clock, so whether you're planning an early morning trip or a late-night return, we are always available to cater to your travel needs. Our customer service team is here to assist you anytime."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Tuljapur journey is simple and convenient with S9 Travels. You can easily book through our website or mobile app, or you can contact our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're traveling to Tuljapur for religious purposes or leisure, we offer customized travel packages tailored to your needs and preferences. Let us know your requirements, and we’ll make sure your trip is special and memorable."
  }
]






















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Tuljapur cab with S9 Travels?',
            answer: 'Booking a cab is simple! You can book online through our website or app, or you can contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Tuljapur trip?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained, designed to provide comfort and safety for long trips.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Tuljapur?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Tuljapur. They ensure a safe and smooth journey, letting you enjoy the trip without any worries.',
          },
          {
            question: 'How do I pay for my Pune to Tuljapur cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round trip from Pune to Tuljapur?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a comfortable and timely return journey from Tuljapur.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Tuljapur?',
            answer: 'Yes, we offer sightseeing services in and around Tuljapur. Explore the famous Tulja Bhavani Temple and other local attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Tuljapur cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Tuljapur?',
            answer: 'Yes, we offer corporate and group travel services to Tuljapur. Whether it’s a corporate outing or a family trip, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Tuljapur journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Tuljapur.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sunil Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my visit to Tuljapur. The driver was punctual, and the vehicle was clean and comfortable. It was a smooth ride, and I felt very safe. Highly recommend S9 Travels for a stress-free trip!”',
        },
        {
          name: 'Mrs. Radhika Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip to Tuljapur was wonderful, thanks to S9 Travels. The driver was professional, and the vehicle was spacious and clean. We had a great time visiting the Tulja Bhavani Temple. We\'ll definitely book again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Tuljapur Cab Booking",
        "description": "Book Pune to Tuljapur taxi services with S9 Travels. We offer one-way, round-trip, luxury taxis, and affordable car rentals for your Tuljapur temple visit. Choose private or Efficient Taxis, enjoy group cab bookings for a comfortable road trip to Tuljapur, and explore the temple tour with a reliable taxi service from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
          <Helmet>
        <title>Pune To Tuljapur Cab Booking | Affordable Taxi & Temple Tour | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Tuljapur cab services for one-way and round-trip rides. Enjoy affordable taxi options, private or Efficient Taxis, and luxury car rentals for your Tuljapur temple tour and road trip. Best rates for Tuljapur cab fare and group bookings." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetotuljapurcabbooking;